var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar-legend" },
    [
      _vm._l(_vm.mapLayers, function (layer) {
        return _c("div", [
          !layer.is_group && !layer.legend_below_title
            ? _c(
                "div",
                [
                  _c("basic-legend-item", {
                    attrs: { layer: layer },
                    on: { "layer-change": _vm.toggleLayer },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !layer.is_group && layer.legend_below_title
            ? _c(
                "div",
                [
                  _c("legend-with-title", {
                    attrs: { layer: layer },
                    on: { "layer-change": _vm.toggleLayer },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          layer.is_group && !layer.is_additional_activity_group
            ? _c(
                "div",
                [
                  _c("legend-with-dropdown", {
                    attrs: { layer: layer },
                    on: { "layer-change": _vm.toggleLayer },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      }),
      _vm._v(" "),
      _c("additional-activities-legend"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }